export const SIGMA_LOADER_TEXT = "Preparing your dashboard";
